import { create } from 'zustand';

// Table size type
export type TableSize = 'small' | 'medium';

// Table preferences interface for localStorage
interface TablePreferences {
  tableSize: TableSize;
}

// Utility functions for localStorage
const getStoredPreferences = (): TablePreferences => {
  const stored = localStorage.getItem('tablePreferences');
  if (!stored) {
    return {
      tableSize: 'small',
    };
  }

  try {
    const parsed = JSON.parse(stored);
    return {
      tableSize:
        parsed.tableSize === 'small' || parsed.tableSize === 'medium'
          ? parsed.tableSize
          : 'small',
    };
  } catch {
    return {
      tableSize: 'small',
    };
  }
};

const setStoredPreferences = (preferences: TablePreferences) => {
  localStorage.setItem('tablePreferences', JSON.stringify(preferences));
};

interface TablePreferencesState {
  // Current preferences
  tableSize: TableSize;

  // Actions
  setTableSize: (size: TableSize) => void;

  // Initialization
  initializePreferences: () => void;
}

export const useTablePreferencesStore = create<TablePreferencesState>(set => ({
  // Default values
  tableSize: 'small',

  setTableSize: (size: TableSize) => {
    set({ tableSize: size });
    setStoredPreferences({ tableSize: size });
  },

  initializePreferences: () => {
    const storedPreferences = getStoredPreferences();
    set(storedPreferences);
  },
}));
